module.exports = __webpack_public_path__ + "static/media/close.28919155.svg";